import CommonFunctions from "./CommonFunctions";
import EditorToolFunctions from "./EditorToolFunctions";
export default class ButtonFunctions {
    static formSubmit(formSelector) {
        formSelector.submit();
    }
    static serializeWithEditor(formSelector, encoded) {
        const editorElement = formSelector.find(".k-editor");
        editorElement.each((index, item) => {
            EditorToolFunctions.createInputForEditor($(item), formSelector, encoded);
        });
        return formSelector.serialize();
    }
    static submit(e) {
        const form = $(e.event.target).closest(".k-button").data("formname");
        const formSelector = $(`#${form}`);
        const formSelectSelector = $(`#${form} select`);
        const dropDownTreeSelector = $(`#${form} [data-role='dropdowntree'][multiple='multiple']`);
        const requiredDateConversionSelector = $(`#${form} [data-role="datepicker"][data-removetimeonsubmit='true']`);
        const validator = formSelector.data().kendoValidator;
        const shouldConfirm = e.sender.wrapper.attr("confirm");
        let validated = false;
        if (validator !== undefined) {
            validated = validator.validate();
        }
        else {
            validated = true;
        }
        if (validated && !shouldConfirm) {
            CommonFunctions.isLoading(formSelector);
        }
        if (validated) {
            e.sender.wrapper.attr('disabled', 'disabled');
            formSelectSelector.each((index, item) => {
                const input = $(item);
                const inputVal = input.val();
                if (!inputVal || (Array.isArray(inputVal) && inputVal.length === 0)) {
                    const selectName = input.attr('name');
                    const selectNameHidden = $(`input:hidden[name='${selectName}']`).val();
                    if (selectNameHidden == null) {
                        $('<input />').attr('type', 'hidden')
                            .attr('name', selectName)
                            .attr('value', "")
                            .appendTo(formSelector);
                    }
                }
            });
            dropDownTreeSelector.each((index, item) => {
                const input = $(item);
                const inputTree = input.data('kendoDropDownTree');
                if (input.val() == null || input.val() === '') {
                    const value = JSON.parse(JSON.stringify(inputTree.value()));
                    input.val(value);
                }
            });
            requiredDateConversionSelector.each((index, item) => {
                const input = $(item);
                const inputDatePicker = input.data('kendoDatePicker');
                input.val(kendo.toString(inputDatePicker.value(), "d"));
            });
        }
        const newAction = e.sender.wrapper.attr('formaction');
        if (newAction) {
            formSelector.attr("action", newAction);
        }
        if (shouldConfirm && validated) {
            CommonFunctions.showConfirm(TextResources.Views_Confirmation, shouldConfirm, () => {
                if (validated) {
                    CommonFunctions.isLoading(formSelector);
                }
                // prevent bsf cache
                ButtonFunctions.preventBfCache();
                ButtonFunctions.formSubmit(formSelector);
            }, () => {
                e.sender.wrapper.removeAttr('disabled');
            });
        }
        else {
            ButtonFunctions.preventBfCache();
            ButtonFunctions.formSubmit(formSelector);
        }
    }
    static preventBfCache() {
        // prevent bsf cache
        window.addEventListener("unload", () => {
            try {
                localStorage.setItem("bfcache-block", Date.now().toString());
            }
            catch (_a) {
                console.warn("no access to local storage");
            }
        });
    }
}
